import { useState } from "react";

export const SelectField = ({
  key = null,
  label,
  id,
  options,
  value,
  onChange,
  disabled
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredOptions = options.filter((option) =>
    typeof option === "object"
      ? option.label.toLowerCase().includes(searchTerm.toLowerCase())
      : option.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="mb-3">
      <label htmlFor={id} className="form-label fw-medium fs">
        {label}
      </label>
      <input
        type="text"
        className="form-control mb-2"
        placeholder={`Search ${label.toLowerCase()}...`}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        disabled={disabled}
      />
      <select
        key={key}
        className="form-select"
        id={id}
        value={value}
        onChange={onChange}
        disabled={disabled}
      >
        <option value="">Select {label.toLowerCase()}</option>
        {filteredOptions.map((option) => (
          <option
            key={typeof option === "object" ? option.value : option}
            value={typeof option === "object" ? option.value : option}
          >
            {typeof option === "object" ? option.label : option}
          </option>
        ))}
      </select>
    </div>
  );
};
